import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PricingAndAccessService {

  constructor(private http: HttpClient) { }

  getPricingAndAccess(): Observable<any>{
    const url = environment.apiURL + `api/pricing-access/list`;
    return this.http.get(url);
  }

  getPricingAndAccessById(id: any): Observable<any>{
    const url = environment.apiURL + `api/pricing-access/list/${id}`;
    return this.http.get(url);
  }

  hotlineMsg(msg: string){
    const url = environment.apiURL + `api/submitHotline`;
    return this.http.post(url, msg);
  }

  addPricingData(updatedData: any): Observable<any>{
    const url = environment.apiURL + 'api/pricing-access';

    let params = new HttpParams();
    params = params.append('title', updatedData.title);
    params = params.append('description', updatedData.description);
    params = params.append('amount', updatedData.amount.toString());
    params = params.append('buttonName', updatedData.buttonName);
    params = params.append('buttonUrl', updatedData.buttonUrl);

    return this.http.post(url, updatedData, { params: params , responseType: 'text' });
  }

  deletePriceCard(id: any): Observable<any> {
    const url = environment.apiURL + `api/pricing-access/` + id;
    return this.http.delete(url, {responseType: 'text'});
  }

  updatePricingData(updatedData: any, id): Observable<any>{
    const url = environment.apiURL + 'api/pricing-access/' + id;
    console.log('inside update pricing data start');

    let params = new HttpParams();
    params = params.append('title', updatedData.title);
    params = params.append('description', updatedData.description);
    params = params.append('amount', updatedData.amount.toString());
    params = params.append('buttonName', updatedData.buttonName);
    params = params.append('buttonUrl', updatedData.buttonUrl);

    return this.http.patch(url, updatedData, { params: params , responseType: 'text' });
  }

  createPayment(stripeToken: any,amount: any, id : any): Observable<any>{
    const url = environment.apiURL + `api/pricing-access/${id}/charge`;

    const formData = new FormData();
    formData.append('id', id);

    let params: HttpParams = new HttpParams();
    params = params.set('stripeToken', stripeToken);
    params = params.set('amount', amount);

    return this.http.post(url, formData, {
      params: params,
      responseType: 'text'
    });
  }

}
